import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import isNumber from 'lodash/isNumber';
import moment from 'moment';
import 'moment-timezone';

import { ReactComponent as Clear } from '../../../assets/img/icons/datepicker/Clear.svg';
import { intervalsDate } from '../../../constants/analytics.constants';
import { deleteSearchParameters, hasTodayQueryParam } from '../../../utils/urlFunctions';
import { isSpecificTimeInIntervalRange } from '../../../utils/time';
import '../DateTimepicker.scss';

export const CustomIntervalSelect = ({
  selectMax = intervalsDate.length,
  selectMin = 1,
  onChange,
  onCancel,
  openCalendar,
  timeInterval,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
  specificTime,
  value,
  displayClearOption = true,
}) => {
  const history = useHistory();
  const isTodaySelected = hasTodayQueryParam();
  let displayTodayOption = true;

  useEffect(() => {
    document.addEventListener('click', checkClick);
  }, []);

  function checkClick(e) {
    if (
      !(e.path || (e.composedPath && e.composedPath())).includes(
        document.getElementById('datepicker_ranges__container')
      )
    ) {
      onCancel(false);
      return document.removeEventListener('click', checkClick);
    }
  }
  
  const getSeconds = (timeString, format) => {
    return moment.duration(timeString, format).asSeconds();
  };

  const onClickToday = () => {
    onChange('today', 'today');
  };

  const changeInterval = (value) => {
    if (value !== 'select') {
      onChange(value, null);
    } else {
      onChange(value, value);
    }
  };
  
  if (specificTime) {
    const todayEndTimeSeconds = getSeconds(moment.tz(moment(), timezone).format('HH:mm'));
    
    if (getSeconds(specificTime.end) > todayEndTimeSeconds) {
      displayTodayOption = false;
    }
  }

  return (
    <div className="datepicker-ranges__container">
      <ul className="datepicker-ranges datepicker-ranges__left-aligned" id="datepicker_ranges__container">
        {intervalsDate.slice(selectMin, selectMax).map((item, i) => {
          if (
            specificTime &&
            isNumber(item.value) &&
            item.value < 86400 &&
            !isSpecificTimeInIntervalRange(specificTime, timezone, item.value)
          ) {
            return null;
          }

          return (
            <li
              key={i}
              className={`datepicker-ranges-item ${
                timeInterval && timeInterval !== null && item.icon === timeInterval.icon
                  ? 'datepicker-ranges-item__active'
                  : ''
              }`}
              onClick={() => {
                changeInterval(item.icon);
              }}
            >
              {item.label}
            </li>
          );
        })}
        
        {displayTodayOption ? (
          <li
            className={cx('datepicker-ranges-item', { 'datepicker-ranges-item__active': isTodaySelected })}
            onClick={onClickToday}
          >
            Today
          </li>
        ) : null}
        
        <li
          className={`datepicker-ranges-item ${
            timeInterval === null && value !== null && value !== 'select' && !isTodaySelected
              ? 'datepicker-ranges-item__active'
              : ''
          }`}
          onClick={() => openCalendar()}
        >
          Custom
        </li>
        
        {displayClearOption ? (
          <li
            className="datepicker-ranges-item datepicker-ranges-item__clear"
            onClick={() => {
              changeInterval('select');
      
              if (specificTime?.onApply) {
                history.push(deleteSearchParameters(['startTimeInterval', 'endTimeInterval']));
                specificTime.onApply(null, null);
              }
            }}
          >
            <Clear />
            Clear
          </li>
        ) : null}
      </ul>
    </div>
  );
};
